<template>
    <div class="previewVideo">
        <van-popup
            class="previewVideoPopup"
            v-model="show"
            closeable
            :close-on-click-overlay="false"
            @click-close-icon="close"
            get-container="body"
        >
            <video
                v-if="show"
                ref="previewVideo"
                autoplay
                controls
            >
                <source :src="url" type="video/mp4">
                <source :src="url" type="video/ogg">
                <source :src="url" type="video/webm">
                <source :src="url" type="video/quicktime">
            </video>
        </van-popup>
    </div>
</template>

<script>
export default {
    name: 'preview-video',
    data() {
        return {
            show: false,
        };
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        autoplay: {
            type: Boolean,
            default: true,
        },
        url: {
            type: String,
            default: '',
        },
    },
    watch: {
        visible(val) {
            if (val) {
                this.show = true;
                if (this.autoplay) {
                    this.$nextTick(() => {
                        this.$refs.previewVideo.play();
                    });
                }
            }
        },
    },
    methods: {
        close() {
            this.$refs.previewVideo.pause();
            this.show = false;
            this.$emit('update:visible', false);
        },
    },
};
</script>

<style lang="stylus">
.previewVideoPopup
    width 100%
    height 100%
    display flex
    justify-content center
    align-items center
    background transparent
    video
        width 100%
        height auto
</style>
